import { StandardSvgProps } from 'src/components/svg/StandardSvgProps';
import { SDefaultSvg, SFilledPath } from 'src/components/svg/SvgStyles';
import theme from 'src/components/themes/DefaultTheme';
import styled from 'src/lib/styles/css';

//#region [Props]
type FilmQuizChairSvgProps = {
} & StandardSvgProps;
//#endregion

//#region [Component]
export default function FilmQuizChairSvg({ className }: FilmQuizChairSvgProps) {
	return (<SDefaultSvg className={className} xmlns="http://www.w3.org/2000/svg" width="106.791" height="106.911" viewBox="0 0 106.791 106.911">
		<g transform="translate(-116.58 -245.5)">
			<SChairARect width="95.711" height="84.912" rx="20" transform="translate(212.431 245.5) rotate(90)" />
			<SChairBRect width="21.879" height="53.656" rx="10" transform="translate(116.58 298.756)" />
			<SChairCRect width="21.879" height="53.656" rx="10" transform="translate(201.492 298.756)" />
			<SChairDRect width="21.879" height="84.912" rx="10" transform="translate(212.431 319.333) rotate(90)" />
			<SChairEPath d="M6.668,27.583H13.64l.061-.727c0-2.3,1.576-2.849,3.819-3.637,4.668-1.637,7.881-5.577,7.881-11.457C25.4,4.486,20.187,0,12.73,0,5.335,0,0,4.425,0,12.912H8.244a4.306,4.306,0,0,1,4.365-4.365c2.546,0,4.3,1.334,4.3,3.759a3.6,3.6,0,0,1-2.425,3.455l-2.243.97C6.608,19.1,6.123,22.49,6.668,26.795Zm3.516,15.277a5.338,5.338,0,1,0,0-10.669,5.338,5.338,0,1,0,0,10.669Z" transform="matrix(1, -0.017, 0.017, 1, 157.305, 262.896)" />
		</g>
	</SDefaultSvg>)
}
//#endregion

//#region [Styles]
const SChairARect = styled.rect`
	fill: ${theme.palette.lillaHovedfarge};
`;

const SChairBRect = styled.rect`
	fill: ${theme.palette.turkis2};
`;

const SChairCRect = styled.rect`
	fill: ${theme.palette.peach};
`;
const SChairDRect = styled.rect`
	fill: ${theme.palette.lilla2};
`;

const SChairEPath = styled.path`
	fill: #fff;
`;
//#endregion